import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { adminInquiryListQuerySchema } from "@kansai-ai-hub/schema";

import { AdminInquiriesPage } from "@/features/admin/inquiries/inquiries-page";
import {
  DEFAULT_INQUIRY_TAB,
  INQUIRY_TABS,
  inquiryStatusesForKind,
} from "@/features/admin/inquiries/kinds";
import {
  adminInquiryListQueryOptions,
  resolveInquiryListQuery,
} from "@/features/admin/inquiries/queries";
import { STATIC_LABELS } from "@/lib/nav-registry";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/inquiries/")({
  staticData: { crumb: { label: STATIC_LABELS.adminInquiries } },
  /**
   * API のクエリスキーマをそのまま使う（画面専用の値を混ぜない）。
   *
   * 対応状況の絞り込みは `statuses`（カンマ区切り）1 つで表す。未指定 = その種別の全状態。
   * 旧 API の `status`（単数）は**受け口で落とす**。画面はこれを送らないので、
   * 古いブックマーク（`?status=DONE`）を残すと「URL には条件が書いてあるのに
   * 絞り込みは効いておらず、画面にもその条件が出ない」状態が延々と持ち回られる。
   * 一覧は状態ごとにグループ分けして畳める形にしたので**ページ送りをしない**
   * （1 つのグループがページをまたいで分断されると、畳む単位と一致しなくなる）。
   * `page` / `pageSize` は URL に残さず、取得側（`resolveInquiryListQuery`）で固定する。
   */
  validateSearch: adminInquiryListQuerySchema.omit({ status: true }).extend({
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(100).optional(),
  }),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const kind = deps.kind ?? DEFAULT_INQUIRY_TAB;
    // 受付前のタブ（ポータル利用申込）は流入が無いので、無駄なリクエストを投げない。
    if (INQUIRY_TABS.find((t) => t.kind === kind)?.pending) return;
    // 画面と同じ解決関数を使い、prefetch したキーと画面が読むキーがずれないようにする
    // （ずれると必ずサスペンドし直す）。
    await context.queryClient.ensureQueryData(
      adminInquiryListQueryOptions(
        resolveInquiryListQuery(deps, kind, inquiryStatusesForKind(kind)),
      ),
    );
  },
  component: AdminInquiriesPage,
});
